const ENABLED_BY_VENUE = 'treatwell-pay-landing-page-enabled-by-venue';
const ENABLED_BY_COUNTRY = 'treatwell-pay-landing-page-enabled-by-country';
// Temporary rollout gate: markets selected on this flag (AT, DE) additionally require POS.
// The markets live on the flag's VENUE_CHANNEL_CODE selector, alongside the wider market
// list on ENABLED_BY_COUNTRY — keep the two in step. Remove the flag and the branch below
// when the rollout finishes.
const REQUIRES_POS = 'treatwell-pay-landing-page-requires-pos';

/**
 * Whether the venue may see the Treatwell Pay landing page.
 *
 * Gates both the header nav entry and direct URL access, so a change here covers
 * both surfaces.
 */
export const isTreatwellPayEligible = (): boolean => {
  const isVisibleForVenue =
    Wahanda.Features.isEnabled(ENABLED_BY_VENUE) || Wahanda.Features.isEnabled(ENABLED_BY_COUNTRY);

  if (!isVisibleForVenue) {
    return false;
  }

  if (Wahanda.Features.isEnabled(REQUIRES_POS)) {
    return Boolean(App.config?.get('venue')?.pointOfSaleEnabled);
  }

  return true;
};
